import React, { useMemo } from 'react'
import { Flex, Grid, Text } from '@chakra-ui/core'
import colors from 'constants/colors'
import './style.css'

interface IProps {
  children: React.ReactNode
  onClickToItem?: (index: number) => void
  maxVisibleItems: number
  itemSize?: string
}

export const FbGrid = ({ children, onClickToItem, maxVisibleItems = 5, itemSize }: IProps) => {
  const Children = React.Children.toArray(children)
  const childrenCount = React.Children.count(children)
  const visibleCount = childrenCount > maxVisibleItems ? maxVisibleItems : childrenCount

  const getClassWrapper = () => `fb-grid-wrapper fb-grid-wrapper-${visibleCount}`

  const customGridStyle = useMemo(() => {
    if (!itemSize) return undefined

    const columnsCount = Math.min(visibleCount, 3)
    const rowsCount = Math.ceil(visibleCount / columnsCount)

    return {
      gridTemplateColumns: `repeat(${columnsCount}, ${itemSize})`,
      gridTemplateRows: `repeat(${rowsCount}, ${itemSize})`,
      gap: '5px',
      borderRadius: '10px',
      overflow: 'hidden' as const,
    }
  }, [itemSize, visibleCount])

  const onClickToItemHandler = (index: number) => {
    if (onClickToItem) {
      onClickToItem(index)
    }
  }

  return (
    <Grid w={itemSize ? 'auto' : '100%'} className={!itemSize ? getClassWrapper() : undefined} style={customGridStyle}>
      {Children.slice(0, maxVisibleItems).map((child, index) => {
        return (
          <Flex
            position="relative"
            key={index}
            className={!itemSize ? `fb-item-${index + 1}` : undefined}
            alignItems="center"
            onClick={() => onClickToItemHandler(index)}
            overflow="hidden"
          >
            {child}
            {childrenCount > maxVisibleItems && index === maxVisibleItems - 1 && (
              <Flex
                position="absolute"
                width="100%"
                height="100%"
                opacity={0.7}
                background={colors.blackLight}
                top="0"
                alignItems="center"
                justifyContent="center"
                zIndex={3}
              >
                <Text fontSize="4xl" color={colors.tealLight}>
                  +{childrenCount - maxVisibleItems}
                </Text>
              </Flex>
            )}
          </Flex>
        )
      })}
    </Grid>
  )
}
